import { Field } from "@progress/kendo-react-form";
import { FormCheckboxMultiSelect, FormDropDownList, ListItem } from "../../form";
import { requiredListValidator, requiredValidator } from "../../../validators";
import { ICompany } from "../Company";

interface IConfigurationCompaniesSelectorProps {
  childCompanies: ICompany[];
  descendentCompanies: ICompany[];
  multiSelect?: boolean;
  isAssign?: boolean;
  onChange?: (value: number) => void;
  onCopy?: (copyCompanyId: number) => void;
}

export const ConfigurationCompaniesSelector = ({
  childCompanies,
  descendentCompanies,
  multiSelect,
  isAssign,
  onChange,
  onCopy,
}: IConfigurationCompaniesSelectorProps) => {


  const companiesToList = (companies: ICompany[]): ListItem[] => {
    return (companies ?? [])
      .map((c) => ({ value: c.id, label: c.name }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }
  
  const childCompanyList = companiesToList(childCompanies);
  const companyToCopyList = [{ label: " ", value: 0 }, ...companiesToList(descendentCompanies)];

  const onChangeCompany = (e: any) => {
    const companyId = e.target.value.value;
    onChange && onChange(companyId);
  };

  const onChangeCopyCompany = (e: any) => {
    const companyId = e.target.value.value;
    onCopy && onCopy(companyId);
  };


  return (
    <div style={{ display: "grid", justifyContent: "center" }}>
      {childCompanyList.length > 0 && (
        <div style={{ minWidth: 300 }}>
          {multiSelect ? (
            <Field
              label="Companies"
              name="companies"
              id="companies"
              component={FormCheckboxMultiSelect}
              validator={requiredListValidator}
              data={childCompanyList}
            />
          ) : (
            <>
              <Field
                label="Company"
                name="company"
                id="company"
                component={FormDropDownList}
                data={childCompanyList}
                textField="label"
                dataItemKey="value"
                validator={requiredValidator}
                onChange={onChangeCompany}
              />

              {isAssign && (
                <Field
                  label="Assign Products From Company"
                  hint="(Optional)"
                  name="companyToCopy"
                  id="companyToCopy"
                  component={FormDropDownList}
                  data={companyToCopyList}
                  textField="label"
                  dataItemKey="value"
                  onChange={onChangeCopyCompany}
                />
              )}
            </>
          )}
        </div>
      )}
      {childCompanyList.length === 0 && (
        <div>There are no companies for which the selected products can be acted upon.</div>
      )}
    </div>
  );
};
